import * as React from 'react';

import { Button } from '@cian/button-component';
import {
  trackInvitePopupAccept,
  trackCheckInvitePopupCancel,
  trackCheckInvitePopupClose,
  trackCheckInvitePopupShow,
} from './tracking';

import * as style from './style.css';
import { CloseIcon } from '../components/close_icon';
import { WhatToDoBlock } from '../components/WhatToDoMessage';

export interface ICheckInvitePopupProps {
  address: string;
  offerLink: string;
  onAccept: React.MouseEventHandler<HTMLElement>;
  onCancel: React.MouseEventHandler<HTMLElement>;
  onClose: React.MouseEventHandler<HTMLElement>;
}

export class CheckInvitePopup extends React.Component<ICheckInvitePopupProps> {
  // eslint-disable-next-line react/no-deprecated
  public componentWillMount() {
    trackCheckInvitePopupShow();
  }

  private handleAcceptClick = (event: React.MouseEvent<HTMLElement>) => {
    trackInvitePopupAccept();
    this.props.onAccept(event);
  };

  private handleCancelClick = (event: React.MouseEvent<HTMLElement>) => {
    trackCheckInvitePopupCancel();
    this.props.onCancel(event);
  };

  private closePopup = (event: React.MouseEvent<HTMLElement>) => {
    trackCheckInvitePopupClose();
    this.props.onClose(event);
  };

  public render() {
    const { address, offerLink } = this.props;

    return (
      <div className={style['moderation-constraint-popup']}>
        <div className={style['moderation-constraint-popup_container']}>
          <div className={style['moderation-constraint-popup_button-close']} onClick={this.closePopup}>
            <CloseIcon />
          </div>
          <p className={style['moderation-constraint-popup_title']}>Пройдите проверку</p>
          <p className={style['moderation-constraint-popup_text']}>
            Ваше объявление{' '}
            <a
              href={offerLink}
              target="_blank"
              rel="nofollow noopener"
              className={style['moderation-constraint-popup_address']}
            >
              {address}
            </a>{' '}
            вызвало подозрения.{' '}
            <p>
              Мы хотим убедиться в отсутствии нарушений. Для того, чтобы ваше объявление не сняли с публикации и/или не
              применили санкцию, необходимо пройти проверку в течение 4-х дней.
            </p>
            <WhatToDoBlock
              message={
                'Напишите на листе ID вашего аккаунта, разместите его в интерьере данного объекта и сделайте фотографию.'
              }
            />
          </p>
          <Button
            onClick={this.handleAcceptClick}
            className={style['moderation-constraint-popup_button-accept']}
            theme="default"
          >
            Пройти проверку
          </Button>
          <Button
            onClick={this.handleCancelClick}
            className={style['moderation-constraint-popup_button-cancel']}
            theme="ghost"
          >
            Снять с публикации
          </Button>
        </div>
      </div>
    );
  }
}
